export default __webpack_public_path__ + "89d9c4f2a391d0c7db04062f09627906.png";